import React, { PureComponent } from 'react'
import { connect } from "react-redux"
import trans from "trans"

import {
    Button,
    DataRow,
    DataCell,
    css,
    Icon,
    Theme,
    Grid,
} from "@bdfx/mergado-ui-kit"

import { updateInputValue as change } from "app/reducers/form"

import { selectLayers, toggleLockLayer } from "../reducers";

import ShapeType, {
    BADGE_TYPE, BEZIER_TYPE, BITMAP_TYPE, BRUSH_TYPE, CIRCLE_TEXT_TYPE, CIRCLE_TYPE, CURVED_TEXT_TYPE, CUSTOM_SET_TYPE, DASHED_FRAME_TYPE,
    DYNAMIC_TEXT_TYPE, EXTERNAL_IMAGE_SOURCE_TYPE, IMAGE_FROM_ELEMENTS_TYPE, LINE_TYPE, POLYGON_TYPE, RATING_TYPE, RECTANGLE_TYPE, SOURCE_IMAGE_TYPE,
    TEXT_TYPE, TEXT_WITH_ELEMENTS_TYPE, TRIANGLE1_TYPE, TRIANGLE2_TYPE
} from "shape-entities/types/shape";

import uniqueId from "app/helpers/unique_id";
import { iconDisabledColor } from "template-edit/components/tools-panel";
import { DEFAULT_FONT_NAME, DEFAULT_FONT_WEIGHT } from "shape-entities/render-text";
import { createGroupFromSelected, getFormName, SOURCE_IMAGE_INDEX } from "shape-edit/forms/helpers";
import { URL } from "app/config/api-config";
import ClipMaskForm from 'shape-edit/forms/clip-mask-form'
import { TEXT_INSIDE_SHAPE_TYPE } from 'shape-entities/types/shape';
import { selectFormValue } from 'app/reducers/form'
import LayerGroupType from 'shape-entities/types/layerGroup'
import { ACTIVE_VIEW_SHAPE_SELECTION } from 'template-edit/containers/Editor'
import { setActiveGroupId, setActiveShapeId, setActiveView } from 'shape-edit/reducers'
import { lowerFirst, omitBy } from 'lodash'
import { IconSearchExternalImage } from 'app/icons'
import { DEFAULT_ASPECT_RATIO_TYPES, EXCLUDE_ASPECT_SIZE_RATIO_TYPES, shouldAspectRatio } from 'shape-entities/defaults'

interface Props {
    isAlt: boolean
    data: ShapeType
    onClick: (event: MouseEvent) => void
    onEdit: Function
    shapes: ShapeType[]
    groups: LayerGroupType[]
    activeShapeId: string
    activeGroupId: string
    selectedLayers: string[]
    lockedLayers: string[]
    sourceSVG: JSX.Element
    isMouseOver: boolean
    setMouseOverShape: Function
    change: typeof change
    toggleLockLayer: typeof toggleLockLayer
    setActiveShapeId: typeof setActiveShapeId
    setActiveGroupId: typeof setActiveGroupId
    setActiveView: typeof setActiveView
    selectLayers: typeof selectLayers
}

class ShapeListItem extends PureComponent<Props> {
    renderPreview() {
        const shape = this.props.data

        if (shape.index === SOURCE_IMAGE_INDEX && this.props.sourceSVG) {
            return this.props.sourceSVG
        }

        return <React.Fragment>
            <LayerPreview color={'#fff'} background={'#fff'}>
                {shape.imageBlob ?
                    <img src={shape.imageBlob} style={{ maxWidth: "50px", maxHeight: "60px", paddingTop: '2px' }} /> :
                    <span className={'shape-preview'}>{getIconByType(shape.type)}</span>
                }

                {shape.clip_mask &&
                    <ClipMaskForm shape={shape} onlyMask={true} />
                }
            </LayerPreview>

        </React.Fragment>
    }

    onClick = (event: MouseEvent) => {
        this.props.onClick(event)
    }

    onEdit = (event) => {
        const shapeId = this.props.data.index
        this.props.onEdit(shapeId, event)
    }

    deleteShape = () => {
        const {isAlt} = this.props
        const shapeId = this.props.data.index
        const shapes = { ...this.props.shapes }
        const newShapes = omitBy(shapes, (value, key) => key === shapeId)
        const formName = getFormName(isAlt)
        this.props.change(formName, "shapes", newShapes)
    }

    toggleHidden = () => {
        const { data, isAlt } = this.props
        const isHidden = data.is_hidden && data.is_hidden === 1
        const formName = getFormName(isAlt)
        this.props.change(formName, `shapes.${data.index}.is_hidden`, isHidden ? 0 : 1)
    }

    toggleLockLayer = () => {
        const { data } = this.props
        const layerIdx = data.index
        this.props.toggleLockLayer(layerIdx)
    }

    toggleAspectRatio = () => {
        const { data, isAlt } = this.props
        const isAspectSizeRatio = data.is_aspect_size_ratio //|| DEFAULT_ASPECT_RATIO_TYPES.includes(data.type)
        const formName = getFormName(isAlt)
        this.props.change(formName, `shapes.${data.index}.is_aspect_size_ratio`, !isAspectSizeRatio)
    }

    duplicateShape = () => {
        const shapeId = this.props.data.index
        const newShapeIndex = uniqueId()
        const { shapes, isAlt } = this.props

        const formName = getFormName(isAlt)

        const duplicatedShape: ShapeType = shapes[shapeId]  //to get old index, old priority, ....

        //count same types with the same name:
        let c = 0
        const newn = duplicatedShape.name ? duplicatedShape.name.replace(/\s*\(\d+\)$/, "") : null
        if (newn) {
            Object.keys(this.props.shapes).forEach((index) => {
                const s = this.props.shapes[index]
                if (s.name) {
                    const n = s.name.replace(/\s*\(\d+\)$/, "")
                    if (n === newn) {
                        c++
                    }
                }
                //console.debug(`before ${s.type} (${s.name}) priority ${s.priority}`)
            })
        }

        const newShape : ShapeType = {
            ...duplicatedShape,
            id: null,
            index: newShapeIndex,
            name: newn && c ? `${newn} (${c})` : duplicatedShape.name,
            priority: duplicatedShape.priority - 1,
            x: typeof duplicatedShape.x !== 'undefined' && duplicatedShape.x !== null ? duplicatedShape.x + 10 : duplicatedShape.x,
            y: typeof duplicatedShape.y !== 'undefined' && duplicatedShape.y !== null ? duplicatedShape.y + 10 : duplicatedShape.y,
        }

        //now reorder by priority:
        let newShapes = {}
        let afterInserted = false
        Object.keys(this.props.shapes).forEach((index) => {
            if (index === duplicatedShape.index) {
                newShapes[newShapeIndex] = newShape
                afterInserted = true
            }

            newShapes[index] = shapes[index]
            if (afterInserted) {
                newShapes[index].priority++
            }
        })

        //Object.keys(newShapes).forEach((index) => {
            //const s = newShapes[index]
            //console.debug(`after ${s.type} (${s.name}) priority ${s.priority}`)
        //})


        this.props.change(formName, "shapes", newShapes)
    }

    handleMouseOver = (index: string) => {
        this.props.setMouseOverShape(index)
    }

    handleRightClick = (e: PointerEvent, shapeIndex: string) => {
        const { selectedLayers, activeGroupId, groups, isAlt } = this.props
        const formName = getFormName(isAlt)

            e.preventDefault();
            if (selectedLayers.length > 0 && selectedLayers.includes(shapeIndex)) {
                if (activeGroupId === null) {
                    //group
                    createGroupFromSelected()
                } else {
                    //ungroup
                    if (groups) {
                        const group = groups.find((g) => g.index === activeGroupId);
                        const newGroups = groups.filter(g => g.index !== activeGroupId)
                        this.props.selectLayers(group.list)
                        this.props.setActiveGroupId(null)
                        this.props.change(formName, 'groups', newGroups)
                    }
                }
            } else {
                //unselect all
                this.props.setActiveShapeId(null)
                this.props.setActiveGroupId(null)
                this.props.setActiveView(ACTIVE_VIEW_SHAPE_SELECTION)
            }
        }

    render() {
        const { data, activeShapeId, selectedLayers, lockedLayers, isMouseOver } = this.props
        const shape = data
        const isActive: boolean = (shape.index === activeShapeId)
        const isSelected: boolean = selectedLayers.includes(shape.index)
        const isLocked: boolean = lockedLayers.includes(shape.index)
        const isAspectRatio: boolean = shape.is_aspect_size_ratio || DEFAULT_ASPECT_RATIO_TYPES.includes(shape.type)
        const isHidden: boolean = (shape.is_hidden === 1)

        let shapeTitle = shape.text_xml_element ? shape.text_xml_element :
            shape.image_xml_element ? shape.image_xml_element :
                shape.rating_xml_element ? shape.rating_xml_element :
                    shape.text_content ? shape.text_content : ''

        let shapeName = shape?.name || ''
        if (shapeName === '') {
            if (shape.is_dynamic) {
                if ([DYNAMIC_TEXT_TYPE, TEXT_INSIDE_SHAPE_TYPE].includes(shape.type) && shape.text_xml_element) {
                    shapeName = shape.text_xml_element;
                } else if (shape.type === IMAGE_FROM_ELEMENTS_TYPE && shape.image_xml_element) {
                    shapeName = shape.image_xml_element;
                } else if (shape.type === TEXT_WITH_ELEMENTS_TYPE && shape.text_content) {
                    shapeName = shape.text_content
                } else if (shape.type === RATING_TYPE && shape.rating_xml_element) {
                    shapeName = shape.rating_from_depots ? `${shapeName} ${lowerFirst(trans('depots_extension'))}` : `${shapeName} ${shape.rating_xml_element} ${shape.rating_count_xml_element && shape.rating_count_xml_element}`;
                }
            } else if (shape.type === EXTERNAL_IMAGE_SOURCE_TYPE && shape.external_image_prompt) {
                shapeName = shape.external_image_prompt
            } else if (shape.text_content) {
                shapeName = shape.text_content
            }
            if (shapeName === '') {
                shapeName = trans(shape.type)
            }
        }

        const isMouseOverClass = (isMouseOver) ? 'mouse-over' : ''
        const isSelectedClass = isSelected ? 'selected-row' : 'not-selected-row'
        const isDynamicStaticClass = shape.is_dynamic ? 'dynamic' : 'static'
        const isActiveShapeClass = isActive ? 'active-row' : ''
        const isHiddenClass = isHidden ? 'hidden-shape' : ''

        return (
            <DataRow
                dataId={shape.index}
                style={{ pointerEvents: 'all', cursor: 'grab' }}
                className={`shapes-list-tr unselectable drag-handle ${isSelectedClass} ${isDynamicStaticClass} ${isActiveShapeClass} ${isHiddenClass} ${isMouseOverClass}`}
            >
                <DataCell key="1" style={{ textAlign: 'center', alignSelf: 'center', overflow: 'hidden' }}>
                    <Button
                        type="void"
                        color="nocolor"
                        icon={<Icon type={'drag-handle-dots-2-radix'} color={isHidden ? iconDisabledColor : Theme.blue} />}
                        style={{ padding: '5px 2px' }}
                    />
                </DataCell>
                <DataCell
                    key="2"
                    onMouseOver={() => this.handleMouseOver(shape.index)}
                    onMouseOut={() => this.handleMouseOver(null)}
                    style={{
                        textAlign: "center",
                        alignSelf: 'center',
                        overflow: 'hidden',
                        pointerEvents: isLocked ? 'none' : 'auto',
                    }}
                    className={`${isHidden ? 'hidden-preview' : ''}`}>
                    <div title={trans(shape.type)}>
                        {this.renderPreview()}
                    </div>
                </DataCell>
                <DataCell
                    key="3"
                    onClick={(e) => this.onClick(e)}
                    onContextMenu={(e) => this.handleRightClick(e, shape.index)}
                    onMouseOver={() => this.handleMouseOver(shape.index)}
                    onMouseOut={() => this.handleMouseOver(null)}
                    className={'shape-name'}
                    title={`${shapeTitle}`}
                    style={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        fontStyle: isHidden ? 'italic' : 'normal',
                    }}>
                    <span style={{pointerEvents: 'none'}}>{shapeName}</span>
                </DataCell>

                <DataCell
                    style={{
                        alignSelf: 'center',
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                    }}>
                    <Button
                        disabled={isLocked}
                        type="void"
                        size="tiny"
                        color="nocolor"
                        icon={<Icon type={'pencil'} color={isHidden ? iconDisabledColor : Theme.blue} />}
                        onClick={(e) => this.onEdit(e)}
                        title={trans("edit_layer")}
                    />
                    <Button
                        disabled={shape.type === SOURCE_IMAGE_TYPE || isLocked}
                        type="void"
                        color="nocolor"
                        size="tiny"
                        icon={<Icon type={isHidden ? 'eye-slash' : 'eye'} color={isHidden ? iconDisabledColor : Theme.blue} size={20} />}
                        onClick={(e) => this.toggleHidden()}
                        title={trans('toggle_visibility')}
                    />
                    <Button
                        type="void"
                        size="tiny"
                        color="nocolor"
                        disabled={shape.type === SOURCE_IMAGE_TYPE || isLocked}
                        icon={<Icon type={'trash'} color={(isHidden || isLocked) ? iconDisabledColor : Theme.blue} />}
                        onClick={(e) => this.deleteShape()}
                        title={trans("delete_layer")}
                    />
                    <Button
                        type="void"
                        size="tiny"
                        color="nocolor"
                        disabled={shape.type === SOURCE_IMAGE_TYPE || isLocked}
                        icon={<Icon type={'copy-light'} color={(isHidden || isLocked) ? iconDisabledColor : Theme.blue} />}
                        onClick={(e) => this.duplicateShape()}
                        title={trans("duplicate_layer")}
                    />
                    <Button
                        type="void" size="tiny" color="nocolor"
                        icon={<Icon type={isLocked ? 'lock' : 'unlock'} color={Theme.blue} />}
                        onClick={(e) => this.toggleLockLayer()}
                        title={trans(isLocked ? "unlock_layer" : "lock_layer")}
                        style={{ marginLeft: '10px' }}
                    />
                    {(!shouldAspectRatio(shape.type) && !EXCLUDE_ASPECT_SIZE_RATIO_TYPES.includes(shape.type)) &&
                        <Button
                            type="void" size="tiny" color="nocolor"
                            icon={<Icon type={isAspectRatio ? 'chain' : 'chain-broken'} color={Theme.blue} />}
                            onClick={(e) => this.toggleAspectRatio()}
                            title={trans("aspect_size_ratio")}
                        />
                    }
                    &nbsp;&nbsp;
                    {!shape.clip_mask &&
                        <ClipMaskForm shape={shape} onlyMask={true} />
                    }
                </DataCell>
            </DataRow>
        )
    }
}

export const LayerPreview = css(Grid)(props => ({
    textAlign: 'center',
    alignSelf: 'center',
    verticalAlign: 'middle',
    width: '68px',
    height: '34px',
    display: 'flex',
    ' .shape-preview': {
        zIndex: 99,
    },
    ' .source-image-preview': {
        width: '32px',
        height: '32px',
    },
}))

export function getIconByType(shapeType: string, iconSize: number = 32, color: string = iconDisabledColor) {
    const textStyle = {
        fontWeight: DEFAULT_FONT_WEIGHT,
        fontFamily: DEFAULT_FONT_NAME,
        fontSize: "16px",
        width: '16px',
    }

    const addClass = color !== iconDisabledColor ? 'filter-color' : ''
    switch (shapeType) {
        case CIRCLE_TEXT_TYPE:
            return <img src={`${URL.publicPath}/img/icons/circle-text.svg`} width={iconSize} height={iconSize} className={`icon-by-type ${addClass}`} />
        case CIRCLE_TYPE:
            return <svg version="1.1" viewBox={`0 0 ${iconSize} ${iconSize}`} width={iconSize} height={iconSize} className={'icon-by-type'}>
                <g>
                    <circle key={`circle_${shapeType}`} r={iconSize / 2} fill={color} transform={`translate(${iconSize / 2}, ${iconSize / 2})`} />
                    <text key={`text_${shapeType}`} dominantBaseline={"central"} textAnchor={"middle"} fill={'#fff'} style={textStyle} transform={`translate(${iconSize / 2}, ${iconSize / 2})`}>
                        T
                    </text>
                </g>
            </svg>
        case RECTANGLE_TYPE:
            return <svg version="1.1" viewBox={`0 0 ${iconSize} ${iconSize}`} width={iconSize} height={iconSize} className={'icon-by-type'}>
                <g>
                    <rect key={`rect_${shapeType}`} width={iconSize} height={iconSize} fill={color} />
                    <text key={`text_${shapeType}`} dominantBaseline={"central"} textAnchor={"middle"} fill={'#fff'} style={textStyle} transform={`translate(${iconSize / 2}, ${iconSize / 2})`}>
                        T
                    </text>
                </g>
            </svg>
        case TRIANGLE1_TYPE:
        case TRIANGLE2_TYPE:
            return <svg version="1.1" viewBox={`0 0 ${iconSize} ${iconSize}`} width={iconSize} height={iconSize} className={'icon-by-type'}>
                <g>
                    <polygon key={`polygon_${shapeType}`} points={`${iconSize},${iconSize} 0,${iconSize} ${iconSize / 2},0 ${iconSize},${iconSize}`} fill={color} />
                    <text key={`text_${shapeType}`} dominantBaseline={"central"} textAnchor={"middle"} fill={'#fff'} style={textStyle} transform={`translate(${iconSize / 2}, ${iconSize / 2 + 4})`}>
                        T
                    </text>
                </g>
            </svg>
        case DASHED_FRAME_TYPE:
            return <svg version="1.1" viewBox={`0 0 ${iconSize} ${iconSize}`} width={iconSize} height={iconSize} className={'icon-by-type'}>
                <g>
                    <rect key={`rect_${shapeType}`} width={iconSize} height={iconSize} fill={'transparent'} stroke={color} strokeWidth={3} />
                </g>
            </svg>
        case EXTERNAL_IMAGE_SOURCE_TYPE:
            return <IconSearchExternalImage size={iconSize} color={color} />
        case TEXT_TYPE:
            return <Icon type={'font'} size={iconSize} color={color} />
        case SOURCE_IMAGE_TYPE:
        case BITMAP_TYPE:
        case BADGE_TYPE:
            return <Icon type={'image'} size={iconSize} color={color} />
        case BRUSH_TYPE:
            return <Icon type={'paint-brush'} size={iconSize} color={color} />
        case IMAGE_FROM_ELEMENTS_TYPE:
            return <img src={`${URL.publicPath}/img/icons/image-from-element.svg`} width={iconSize} height={iconSize} className={`icon-by-type ${addClass}`} />
        case RATING_TYPE:
            return <img src={`${URL.publicPath}/img/icons/rating.svg`} width={iconSize} height={iconSize} className={`icon-by-type ${addClass}`} />
        case DYNAMIC_TEXT_TYPE:
            return <Icon type={'code'} size={iconSize} color={color} />
        case TEXT_INSIDE_SHAPE_TYPE:
            return <img src={`${URL.publicPath}/img/icons/text-inside-shape.svg`} width={iconSize} height={iconSize} className={`icon-by-type ${addClass}`} />
        case CUSTOM_SET_TYPE:
            return <Icon type={'cloud-upload-light'} size={iconSize} color={color} />
        case TEXT_WITH_ELEMENTS_TYPE:
            return <Icon type={'file-code-o'} size={iconSize} color={color} />
        case POLYGON_TYPE:
            return <img src={`${URL.publicPath}/img/icons/polygon.svg`} width={iconSize} height={iconSize} className={`icon-by-type ${addClass}`} />
        case BEZIER_TYPE:
            return <img src={`${URL.publicPath}/img/icons/bezier.svg`} width={iconSize} height={iconSize} className={`icon-by-type ${addClass}`} />
        case CURVED_TEXT_TYPE:
            return <img src={`${URL.publicPath}/img/icons/curve-text.svg`} width={iconSize} height={iconSize} className={`icon-by-type ${addClass}`} />
        case LINE_TYPE:
            return <Icon type={'pencil'} size={iconSize} color={color} />
        default:
            return <span />
    }
}


function mapStateToProps(state) {
    const formName = state.isAlt ? 'altTemplateForm' : 'templateForm'
    return {
        isAlt: state.isAlt,
        groups: selectFormValue(state, formName, 'groups'),
        shapes: selectFormValue(state, formName, 'shapes'),
        activeShapeId: state.activeShapeId,
        activeGroupId: state.activeGroupId,
        selectedLayers: state.selectedLayers,
        lockedLayers: state.lockedLayers,
    }
}

export default connect(mapStateToProps, {
    change,
    toggleLockLayer,
    setActiveShapeId,
    setActiveGroupId,
    setActiveView,
    selectLayers,
})(ShapeListItem)